import Animated, {
  useAnimatedStyle,
  SharedValue,
} from "react-native-reanimated";
import React, { useEffect } from "react";
import { Platform, TouchableWithoutFeedback } from "react-native";
import { BlurView } from "expo-blur";

export function AnimatedBackdrop({
  animation,
  onPress,
}: {
  animation: SharedValue<number>;
  onPress: () => void;
}) {
  const style = useAnimatedStyle(() => {
    return {
      top: 0,
      left: 0,
      backgroundColor: "rgba(0,0,0,0.4)",
      position: "absolute",
      width: "100%",
      height: "100%",
      opacity: animation.value,
    };
  }, []);

  const [render, setRender] = React.useState(Platform.OS === "web");
  useEffect(() => {
    setTimeout(() => {
      setRender(true);
    }, 10);
  }, []);

  const intensity = Platform.OS === "web" ? 40 : 85;
  return (
    <Animated.View style={style}>
      <TouchableWithoutFeedback onPress={onPress} style={{ flex: 1 }}>
        <BlurView
          intensity={render ? intensity : 0}
          tint="dark"
          style={{ flex: 1 }}
        />
      </TouchableWithoutFeedback>
    </Animated.View>
  );
}
